import { useEffect, useState } from "react";
import { useAuth } from "../../hooks/useAuth";
import { getAssignedPromoters, sendNotification } from "../../firebase/services";
import { useLanguage } from "../../hooks/useLanguage";

export default function SupervisorNotifSend() {
  const { t } = useLanguage();
  const { user } = useAuth();
  const [promoters, setPromoters] = useState([]);
  const [form, setForm] = useState({ title: "", body: "", target: "all" });
  const [selected, setSelected] = useState([]);
  const [sending, setSending] = useState(false);
  const [msg, setMsg] = useState("");

  useEffect(() => {
    if (!user) return;
    getAssignedPromoters(user.uid).then(setPromoters);
  }, [user]);

  const toggleSelect = (uid) => {
    setSelected(s => s.includes(uid) ? s.filter(x => x !== uid) : [...s, uid]);
  };

  const handleSend = async (e) => {
    e.preventDefault();
    if (!form.title.trim() || !form.body.trim()) { setMsg("Vui lòng nhập tiêu đề và nội dung."); return; }
    if (form.target === "selected" && selected.length === 0) { setMsg("Vui lòng chọn ít nhất 1 promoter."); return; }
    setSending(true);
    try {
      const sentTo = form.target === "all" ? promoters.map(p => p.uid) : selected;
      await sendNotification({ title: form.title, body: form.body, fileUrl: null, sentTo });
      setMsg("✅ Đã gửi thông báo thành công!");
      setForm({ title: "", body: "", target: "all" });
      setSelected([]);
    } catch (err) {
      setMsg("Lỗi: " + err.message);
    } finally {
      setSending(false);
      setTimeout(() => setMsg(""), 4000);
    }
  };

  return (
    <>
      <div className="page-header">
        <div><h1>{t("notif.title")}</h1><p>{t("notif.subtitle")}</p></div>
      </div>

      {msg && <div className={`alert ${msg.startsWith("✅") ? "alert-success" : "alert-error"}`}>{msg}</div>}

      <div className="card">
        <form onSubmit={handleSend}>
          <div className="form-group">
            <label className="form-label">{t("notif.title_field")}</label>
            <input value={form.title} onChange={e => setForm(f => ({ ...f, title: e.target.value }))} placeholder={t("notif.title_field")} required />
          </div>
          <div className="form-group">
            <label className="form-label">{t("notif.body")}</label>
            <textarea value={form.body} onChange={e => setForm(f => ({ ...f, body: e.target.value }))} rows={4} placeholder={t("notif.body")} required style={{ width: "100%", padding: "8px 12px", borderRadius: 8, border: "1px solid #e5e7eb", fontSize: 14, resize: "vertical" }} />
          </div>
          <div className="form-group">
            <label className="form-label">{t("notif.send_to")}</label>
            <div style={{ display: "flex", gap: 16 }}>
              <label style={{ display: "flex", alignItems: "center", gap: 6, cursor: "pointer" }}>
                <input type="radio" name="target" value="all" checked={form.target === "all"} onChange={() => setForm(f => ({ ...f, target: "all" }))} />
                {t("notif.all_promoters")} ({promoters.length})
              </label>
              <label style={{ display: "flex", alignItems: "center", gap: 6, cursor: "pointer" }}>
                <input type="radio" name="target" value="selected" checked={form.target === "selected"} onChange={() => setForm(f => ({ ...f, target: "selected" }))} />
                {t("notif.select_specific")}
              </label>
            </div>
          </div>
          {form.target === "selected" && (
            <div className="form-group">
              <label className="form-label">{t("sales.promoter")}</label>
              <div style={{ display: "flex", flexWrap: "wrap", gap: 8 }}>
                {promoters.map(p => (
                  <button
                    key={p.uid} type="button"
                    className={"btn btn-sm" + (selected.includes(p.uid) ? " btn-primary" : "")}
                    onClick={() => toggleSelect(p.uid)}
                  >
                    {p.name}
                  </button>
                ))}
              </div>
            </div>
          )}
          <button className="btn btn-primary" type="submit" disabled={sending}>
            {sending ? "Đang gửi..." : "📢 " + t("notif.send_btn")}
          </button>
        </form>
      </div>
    </>
  );
}
